import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

interface WrapperProps {
  isDisabled?: string;
}

export const ProgressBarTitle = styled(Text)<WrapperProps>`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  user-select: none;
  margin-left: ${({ theme }) => theme.spacings.xs};
  line-height: 22px;
`;

interface NavButtonProps {
  isDisabled?: boolean;
}

export const NavButton = styled.button<NavButtonProps>`
  flex: 1;
  transition: all 0.15s;
  background-color: ${({ theme }) => theme.colors.canvas};
  border: none;
  border-radius: ${({ theme }) => theme.rounds.button1Round};
  height: 54px;
  padding: ${({ theme }) => theme.spacings.xxs}  ${({ theme }) => theme.spacings.s};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background-color: ${({ theme, isDisabled }) => (isDisabled ? 'none' : theme.colors.border1)};
  }
`;

export const Delimiter = styled(Box)`
  position: relative;
  width: 100%;
  height: 16px;
  margin: 32px 0;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    flex: 1;
    height: 2px;
    background: ${({ theme }) => theme.colors.border1};
    border-radius: 1px;
    display: block;
  }

  &::after {
    content: '';
    display: block;
    width: 24px;
    height: 16px;
    background: transparent;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    /* Малюємо галочку SVG через background-image */
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 13L15 10M12 13L9 10' stroke='%23e9ecf3' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const SummaryBox = styled(Box)`
  transition: all 0.15s;
  span {
    transition: all 0.15s;
  }
  a {
    height: 24px;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.border1};
    a span {
      background-color: ${({ theme }) => theme.colors.border1};
    }
  }
`;

interface RenewOptionCardWrapperProps {
  isChecked?: boolean;
  isDisabled?: boolean;
}

export const RenewOptionCardWrapper = styled(Box)<RenewOptionCardWrapperProps>`
  border: ${({ isChecked, theme }) => isChecked ? `2px solid ${theme.colors.border1}` : '2px solid transparent'};
  box-shadow: ${({ isChecked, theme }) => {
    if (!isChecked) {
      return `0 0 0 1px ${theme.colors.border1}`;
    }
    return 'none';
  }};
  ${({ theme, isDisabled }) => !isDisabled && `
    &:hover {
      border: 2px solid ${theme.colors.border1};
      box-shadow: none;
    }
  `}
  cursor: ${({ isDisabled }) => isDisabled ? 'not-allowed' : 'cursor'};
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.textAccent};
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.textAccentHover};
  }
`;
